import React, { useCallback, useEffect, useState } from "react";
import { Box, Button, Flex, Image, Text } from "@chakra-ui/react";
import heroImg from "../Assets/Images/memberupgrade-hero-img.svg";
import { BASE_URL } from "../config/settings";
import httpRequest from "../utils/httpRequest";
import { useDispatch, useSelector } from "react-redux";
import {
  setFeepaymentId,
  setFeePaymentDetail,
} from "../redux/slices/individualApplicationApprovalSlice";
import { setloadTost } from "../redux/slices/toastSlice";
import { setFormModal } from "../redux/slices/modalSlice";
import { useNavigate } from "react-router-dom";
import { removeUser } from "../redux/slices/authSlice";

const SubmittedApprovedAppllications = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const paymentConfirmation = useSelector(
    (state) => state?.individualApplicationApproval?.paymentConfirmation
  );

  const feePaymentId = useSelector(
    (state) => state?.individualApplicationApproval?.feepaymentId
  );

  const signOut = () => {
    dispatch(removeUser());
    localStorage.removeItem("persist:root");
    navigate("/");
  };

  const appFeePayment = useCallback(async () => {
    try {
      const response = await httpRequest(
        `${BASE_URL}/v2/Application/fee-payment`,
        "post"
      );
      if (response?.isSuccess && response?.feePaymentId) {
        dispatch(setFeepaymentId(response?.feePaymentId));
      }
    } catch (err) {
      console.error("Error fetching fee payment ID:", err);
    }
  }, [dispatch]);

  useEffect(() => {
    appFeePayment();
  }, [appFeePayment]);

  const handlMakePayment = async () => {
    setLoading(true);
    setError("");
    try {
      const response = await httpRequest(
        `${BASE_URL}/v2/Payment/${feePaymentId}/generate-remita`,
        "post"
      );

      if (response?.isSuccess) {
        dispatch(setFeePaymentDetail(response));
        dispatch(
          setFormModal({
            status: true,
            title: "Payment Details",
            type: "regPaymentDetails",
            data: response,
          })
        );
      } else {
        const errorMessage =
          response?.payload?.data?.error?.description ||
          "Failed to get fee payment";
        setError(errorMessage);
        dispatch(
          setloadTost({
            title: "Error",
            description: errorMessage,
            status: "warning",
            duration: 5000,
            isClosable: true,
            position: "top",
          })
        );
      }
    } catch (err) {
      setError("Failed to get fee payment, please check your request/network");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      mx={"40px"}
      mt={"20px"}
      borderRadius={"20px"}
      bgGradient="linear(to-r, #3ACB72, #D8F5E3)"
    >
      <Flex
        px={10}
        py={6}
        flexDirection={["column", "row", "row"]}
        justifyContent={["center", "space-between", "space-between"]}
        alignItems={"center"}
        gap={"20px"}
      >
        {paymentConfirmation ? (
          <Flex
            flexDirection={"column"}
            fontFamily={"inter"}
            gap={3}
            color={"#FFFFFF"}
            letterSpacing={"-0.15px"}
          >
            <Text fontWeight={"500"} fontSize={"16px"}>
              Congratulations! Your payment has been processed successfully.
            </Text>
            <Text fontWeight={"500"} fontSize={"16px"}>
              Please proceed to login to your Member Profile.
            </Text>
            <Button
              mt={3}
              borderRadius={"12px"}
              bgColor={"#7D2B32"}
              color={"#FFFFFF"}
              fontWeight={"700"}
              fontSize={"16px"}
              _hover={{ bgColor: "#6C252A" }}
              _active={{ bgColor: "#5B1F24" }}
              onClick={signOut}
            >
              Login
            </Button>
          </Flex>
        ) : (
          <Flex
            flexDirection={"column"}
            fontFamily={"inter"}
            gap={3}
            color={"#FFFFFF"}
            letterSpacing={"-0.15px"}
          >
            <Text fontWeight={"700"} fontSize={"20px"}>
              Hello Applicant
            </Text>
            <Text fontWeight={"500"} fontSize={"14px"}>
              Your application has been approved successfully.
            </Text>
            <Text fontWeight={"500"} fontSize={"14px"}>
              Please proceed to make your payment.
            </Text>
            {error && (
              <Text color="green.500" fontSize="12px">
                {error}
              </Text>
            )}
            <Button
              mt={3}
              borderRadius={"12px"}
              bgColor={"#D8F5E3"}
              color={"#121212"}
              fontWeight={"700"}
              fontSize={"14px"}
              _hover={{ bgColor: "#3ACB72" }}
              _active={{ bgColor: "#5B1F24" }}
              onClick={handlMakePayment}
              isLoading={loading}
              loadingText="Loading ..."
            >
              Make Payment
            </Button>
          </Flex>
        )}
        <Image src={heroImg} alt="Student Hero Image" h={"230px"} w={"250px"} />
      </Flex>
    </Box>
  );
};

export default SubmittedApprovedAppllications;
